import { gql, useQuery } from '@apollo/client'
import { getIsSessionExpired } from '../../utils/is-session-expired.js'

export const CAPABILITIES_QUERY = gql`
  query UseCapabilities {
    account {
      id
      program {
        code
      }
      capabilities {
        canEditBusinessIdentity: editBusinessIdentity
        hasEqxReports: premiumReportsEquifax
        isCtaEnabled: ctaEnabled
        isPremiumAccount: premiumReport
        isMarketplaceEnabled: marketplace
        isMarketPlaceCCsEnabled: marketplaceCCs
        isMarketPlaceLoansEnabled: marketplaceLoans
        isStandardReportsExperian: standardReportsExperian
        isPremiumReportEquifax: premiumReportsEquifax
        isPremiumReportExperian: premiumReportsExperian
        hasCreditScoreExperian: creditScoreExperian
        pppEnabled
      }
    }
  }
`

export const useCapabilities = () => {
  const isSessionExpired = getIsSessionExpired()

  const resp = useQuery(CAPABILITIES_QUERY, {
    skip: isSessionExpired,
  })
  const { capabilities = {}, program = {} } = resp?.data?.account ?? {}
  const isPremiumReportExperian = capabilities.isPremiumReportExperian
  const isStandardReportExperian = capabilities.isStandardReportsExperian
  const isMarketPlaceCCsEnabled = capabilities.isMarketPlaceCCsEnabled
  const isMarketPlaceLoansEnabled = capabilities.isMarketPlaceLoansEnabled
  const isMarketPlaceEnabled = capabilities.isMarketplaceEnabled

  const isMarketplaceOnly = [isMarketPlaceCCsEnabled, isMarketPlaceLoansEnabled, isMarketPlaceEnabled].every(Boolean)

  const isCreditReportsEnabled = [isPremiumReportExperian, isStandardReportExperian].some(Boolean)

  const isDfaEnabled = [
    program?.code?.startsWith('clover_'),
    !program?.code?.includes('no_market'),
    !program?.code?.includes('bams'),
  ].every(Boolean)

  const isInactiveUser = program.code?.endsWith('_inactive')

  return {
    ...resp, // Provide all the other Apollo things
    ...capabilities,
    isCreditReportsEnabled,
    isMarketplaceOnly,
    isInactiveUser,
    isDfaEnabled,
  }
}

/**
 * This is useful for class components that would like to benefit from the hook.
 */
export const withCapabilities = (Component) => (props) => {
  const resp = useCapabilities()
  return <Component {...props} useCapabilities={resp} />
}
